(function () {
  var iconOn = "M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320ZM400-606l-86 86H200v80h114l86 86v-252ZM300-480Z";
  var iconOff = "M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z";

  function sync(button, video) {
    var muted = video.muted;
    button.setAttribute("aria-pressed", muted ? "true" : "false");
    button.setAttribute("aria-label", muted ? "Unmute" : "Mute");
    var path = button.querySelector("path");
    if (path) path.setAttribute("d", muted ? iconOff : iconOn);
  }

  function start(video, button, muted) {
    video.muted = muted;
    video.playsInline = true;
    sync(button, video);
    var attempt = video.play();
    if (!attempt || !attempt.then) return;
    attempt.then(function () {
      var play = video.closest("[data-udumbara-film]") && video.closest("[data-udumbara-film]").querySelector(".ur-play");
      if (play) play.hidden = true;
    }).catch(function () {
      if (!video.muted) {
        video.muted = true;
        sync(button, video);
        video.play().then(function () {
          var play = video.closest("[data-udumbara-film]") && video.closest("[data-udumbara-film]").querySelector(".ur-play");
          if (play) play.hidden = true;
        }).catch(function () {});
      }
    });
  }

  document.querySelectorAll("[data-udumbara-mute]").forEach(function (button) {
    var root = button.closest("[data-udumbara-film]");
    var video = root && root.querySelector("video");
    if (!video) return;
    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      start(video, button, !video.muted);
    });
    start(video, button, false);
  });
})();
